import React from 'react';
import { DSAlert, DSIcon } from '../design-system/primitives';
import { isEventCancelled } from '../utils/eventHelpers';
import './EventCancelledBanner.css';

/**
 * The one unmistakable line at the top of a cancelled event's page. A cancelled event stays
 * reachable on purpose, so the people who planned on it find out, which means every page
 * that shows one has to say so before anything else. Renders nothing for an event that is on.
 *
 * `note` is for whoever can still act on it, such as an admin being told the management
 * tools below are still live.
 */
function EventCancelledBanner({ event, note = null }) {
  if (!isEventCancelled(event)) return null;

  return (
    <div className="event-cancelled-banner">
      <DSAlert variant="error" appearance="outline">
        <div className="event-cancelled-banner__row">
          <DSIcon name="warning" size="md" tone="danger" />
          <div className="event-cancelled-banner__text">
            <p className="event-cancelled-banner__title">This event is cancelled</p>
            {event.cancellation_reason && (
              <p className="event-cancelled-banner__reason">{event.cancellation_reason}</p>
            )}
            {note && <p className="event-cancelled-banner__note">{note}</p>}
          </div>
        </div>
      </DSAlert>
    </div>
  );
}

export default EventCancelledBanner;
